/**
 * variant-pre-order-message.js
 * Theme: Swipe 1.3.0. Loaded only for variant products, inside the
 * product-level pre-order popup block (release_date is set + still future).
 *
 * SOLE JOB: when the selected variant's <label> carries the [data-preorder]
 * marker (set in product-variant-options from custom.pre_order_yes_no),
 * change the add-to-cart button label to "Pre-Order"; revert otherwise.
 *
 * Does NOT touch the .custom-release-date-true popup — that is a PRODUCT-LEVEL
 * element controlled entirely by Liquid. Variant selection must not hide it.
 *
 * Swipe re-renders its own button <span> on variant change, so we inject our
 * own label span and hide Swipe's while active, removing ours on revert.
 * NOTE: single-option products only. [data-preorder] via value.variant only
 * resolves for option position 1; multi-option products need a variant-id map.
 * Skips the Shop Pay installments form.
 */
(function () {
  'use strict';

  var PREORDER_LABEL = 'Pre-Order';

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
    if (
      form.classList.contains('installment') ||
      form.closest('.installment') ||
      form.closest('.installment-wrapper') ||
      form.querySelector('shopify-payment-terms')
    ) {
      return;
    }
    setupForm(form);
  });

  function setupForm(form) {
    const scope = form.closest('section') || document;

    const render = function () {
      const isPreOrder = selectedVariantIsPreOrder(scope);

      const themeSpan = getBtnSpan(form);
      if (!themeSpan) return;

      let ourSpan = form.querySelector('[data-pre-order-btn-label]');
      if (isPreOrder) {
        if (!ourSpan) {
          ourSpan = document.createElement('span');
          ourSpan.setAttribute('data-pre-order-btn-label', '');
          themeSpan.parentNode.insertBefore(ourSpan, themeSpan.nextSibling);
        }
        ourSpan.textContent = PREORDER_LABEL;
        ourSpan.style.display = '';
        themeSpan.style.display = 'none';
      } else {
        themeSpan.style.display = '';
        if (ourSpan) ourSpan.remove();
      }
    };

    const deferredRender = function () {
      setTimeout(render, 60);
    };

    scope.addEventListener('change', function (e) {
      if (e.target.matches('input[type="radio"], select')) deferredRender();
    });

    // Swipe's variant-radios / variant-selects custom elements may dispatch
    // their own change; the native change above covers the radio/select input.

    render();
  }

  // Pre-order when the selected variant's <label> carries [data-preorder].
  function selectedVariantIsPreOrder(scope) {
    const label = getSelectedLabel(scope);
    return !!label && label.hasAttribute('data-preorder');
  }

  // Swipe's button label span: first <span> inside .product-form__submit.
  function getBtnSpan(form) {
    const submit = form.querySelector('.product-form__submit');
    return submit ? submit.querySelector('span') : null;
  }

  function getSelectedLabel(scope) {
    const checked = scope.querySelector('input[type="radio"]:checked');
    if (!checked) return null;

    if (checked.id) {
      const byFor = scope.querySelector('label[for="' + CSS.escape(checked.id) + '"]');
      if (byFor) return byFor;
    }
    const wrapping = checked.closest('label');
    if (wrapping) return wrapping;

    const next = checked.nextElementSibling;
    if (next && next.matches('label')) return next;

    return null;
  }
})();